import { render, html, nothing } from "lit-html";
import { repeat } from "lit-html/directives/repeat.js";
import connect from "../../../shared/data-store/connect";
import { translate } from "../../../shared/l10n/translate";
import {
	ACTION_REMOVE_ALL_FILTER,
	ACTION_REMOVE_TOGGLE_FILTER,
	ACTION_RESET_BOARD_FILTER,
	ACTION_RESET_CANCELATION_FILTER,
	ACTION_RESET_PRICE_FILTER,
	ACTION_RESET_SCORE_FILTER,
	ACTION_RESET_CLASSIFICATION_FILTER,
	store,
} from "./DataStore";
import { track } from "../../tracker/EventTracker";
import { getFormatter } from "../../../shared/l10n/currency";
import { travelData } from "../../state/travelData";
import { getFilter } from "../../state/hotel-list/get-category-fitlers";
import * as Board from "../board";
import * as Classification from "@escapio/portal/components/classification";

export const trackReset = label => track("Filter", "Filter entfernen", label);
let filterHistory = [];

customElements.define(
	"esc-hotel-list-reset-filters",
	class extends connect(HTMLElement, store) {
		update(state) {
			filterHistory = filterHistory.filter(({ check }) => check(state));
			const format = getFormatter(travelData.currency);

			["hotelTypes", "criteria"].forEach(filterCategory => {
				state.filters[filterCategory].forEach(filterId => {
					const { label } = getFilter(filterCategory, filterId);
					this.addFilter({
						id: `${filterCategory}_${filterId}`,
						label,
						check: newState =>
							newState.filters[filterCategory].includes(filterId),
						onClick: () => {
							trackReset(label);
							this.dispatchAction(ACTION_REMOVE_TOGGLE_FILTER, {
								name: filterCategory,
								value: filterId,
							});
						},
					});
				});
			});

			if (state.filters.price) {
				const formattedPrice = format(state.filters.price);
				this.addFilter({
					id: "price",
					label: translate("filter_price_label_total_rate", formattedPrice),
					check: newState => newState.filters.price === state.filters.price,
					onClick: () => {
						trackReset(formattedPrice);
						this.dispatchAction(ACTION_RESET_PRICE_FILTER);
					},
				});
			}

			if (state.filters.reviewScore) {
				const score = state.filters.reviewScore;
				this.addFilter({
					id: "reviewScore",
					label: `${translate("filter_score_label")} ${translate(
						"filter_score_label_from",
						score + "%",
					)}`,
					check: newState => newState.filters.reviewScore === score,
					onClick: () => {
						trackReset(score);
						this.dispatchAction(ACTION_RESET_SCORE_FILTER);
					},
				});
			}

			if (state.filters.board != Board.NONE) {
				this.addFilter({
					id: "board",
					label: Board.OPTIONS[state.filters.board],
					check: newState => newState.filters.board === state.filters.board,
					onClick: () => {
						trackReset("Verpflegung");
						this.dispatchAction(ACTION_RESET_BOARD_FILTER);
					},
				});
			}

			if (state.filters.classification != Classification.ALL) {
				this.addFilter({
					id: "classification",
					label: Classification.LONG_LABELS[state.filters.classification],
					check: newState =>
						newState.filters.classification === state.filters.classification,
					onClick: () => {
						trackReset(
							Classification.TRACKING_LABELS[state.filters.classification],
						);
						this.dispatchAction(ACTION_RESET_CLASSIFICATION_FILTER);
					},
				});
			}

			if (state.filters.cancelation) {
				this.addFilter({
					id: "cancelation",
					label: translate("basic_free_cancelation"),
					check: newState =>
						newState.filters.cancelation === state.filters.cancelation,
					onClick: () => {
						trackReset("Kostenlose Stornierung");
						this.dispatchAction(ACTION_RESET_CANCELATION_FILTER);
					},
				});
			}

			if (filterHistory.length) {
				this.classList.add("filter-reset-container--show");
			} else {
				this.classList.remove("filter-reset-container--show");
			}

			const template = html` ${filterHistory.length > 2
				? html`<button
						class="filter-reset filter-reset--all"
						@click=${this.resetAll}
					>
						${translate("filter_reset_all")}
						<span class="filter-reset__cross close-icon"></span>
					</button>`
				: nothing}
			${repeat(
				filterHistory,
				({ id }) => id,
				({ label, onClick }) =>
					html`<button class="filter-reset" @click=${onClick}>
						${label}<span class="filter-reset__cross close-icon"></span>
					</button>`,
			)}`;

			render(template, this, { host: this });
		}

		addFilter(filter) {
			if (filterHistory.find(({ id }) => id === filter.id)) {
				// do not create reset button if already existing for this item
				return;
			}

			filterHistory.unshift(filter); // Reverse order. Newest first.
		}

		resetAll() {
			trackReset("Alle Filter entfernen");
			this.dispatchAction(ACTION_REMOVE_ALL_FILTER);
		}
	},
);
